export type Tag = string | number | boolean | null | undefined;
export type Tags = {
  [key: string]: Tag;
};

const globalTags: Tags = {};

/**
 * This functions lets you set tags that will last throughout the rest of the session,
 * and will get added to each later error.
 * @param tags Object of key value pairs
 */
export function setAppSpecificTags(tags: Tags) {
  Object.keys(tags).forEach((key) => {
    // add tag name to value for searching since AS doesn't allow search by name
    globalTags[key] = `${key}_${String(tags[key] ?? 'NOT_SET')}`;
  });
}
/**
 * This functions lets you add tags that will last throughout the rest of the session,
 * and will get added to each later error.
 * @param key string
 * @param value string
 */
export function addAppSpecificTag(key: string, value: Tag) {
  // add tag name to value for searching since AS doesn't allow search by name
  globalTags[key] = `${key}_${String(value ?? 'NOT_SET')}`;
}

export function getTags() {
  return globalTags;
}
